"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Density_1 = require("@becrop/components/Toolkit/Common/models/Density");
const trans_1 = require("@common/tsutils/trans");
const Tab_1 = __importDefault(require("@becrop/components/Toolkit/Common/models/Tab"));
const Cluster_1 = __importDefault(require("@becrop/components/Toolkit/Common/models/Cluster"));
const Loader_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/Loader.vue"));
const Tabs_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/Tabs.vue"));
const BoxPlot_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/BoxPlot.vue"));
const Probability_vue_1 = __importDefault(require("./components/Probability.vue"));
const Map_vue_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/vue/components/Map.vue"));
const lodash_1 = __importDefault(require("lodash"));
const lucide_vue_next_1 = require("lucide-vue-next");
function uniq(a) {
    return a.sort().filter(function (item, pos, ary) {
        return !pos || item !== ary[pos - 1];
    });
}
let MetricPlot = class MetricPlot extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.mode = this.dimension === 'bio' ? '100%' : 'real';
        this.filteredMetrics = this.metrics;
        this.metricTypes = ['ALL', ...uniq(this.metrics.map((m) => (m === null || m === void 0 ? void 0 : m.typeCode) + ''))];
        this.selectedMetricType = this.metricTypes[0];
        this.selectedMetric = this.metrics.length ? this.metrics[0] : null;
        this.plots = null;
        this.fetching = true;
        this.minAvg = 0;
        this.diffAvg = '';
        this.domCluster = '';
        this.options = this.dimension === 'bio'
            ? [
                new Tab_1.default({
                    mode: '100%',
                    name: (0, trans_1.trans)('toolkit.abun_boxplot.domain.standard') + ' 0-100 BCS',
                    active: true,
                }),
                new Tab_1.default({
                    mode: 'real',
                    name: (0, trans_1.trans)('toolkit.abun_boxplot.domain.custom'),
                    active: false,
                }),
            ]
            : [
                new Tab_1.default({
                    mode: 'real',
                    name: (0, trans_1.trans)('toolkit.abun_boxplot.domain.custom'),
                    active: true,
                }),
            ];
        this.samplesWithLocationA = [];
        this.samplesWithLocationB = [];
        this.mapToggled = false;
    }
    toggleMap() {
        if (this.mapAvailable)
            this.mapToggled = !this.mapToggled;
        if (this.mapToggled) {
            // @ts-ignore
            this.$refs.plotmap2.scrollIntoView({ behavior: 'smooth' });
        }
        else {
            // @ts-ignore
            document.getElementById('vue-app').scrollIntoView({ behavior: 'smooth' });
        }
    }
    mounted() {
        var _a, _b;
        if (this.parsedMetricPlots[0].density && this.parsedMetricPlots[1].density) {
            let avgDiff = Math.round(((_a = this.parsedMetricPlots[0].density) === null || _a === void 0 ? void 0 : _a.average) -
                ((_b = this.parsedMetricPlots[1].density) === null || _b === void 0 ? void 0 : _b.average));
            if (this.dimension === 'phch') {
                avgDiff = Math.round(this.metricPlot.becropScoreChange);
            }
            if (avgDiff > 0) {
                this.diffAvg = '+' + avgDiff;
                this.minAvg = this.parsedMetricPlots[1].density.average;
                this.domCluster = 'cluster--2';
            }
            else {
                this.diffAvg = '' + avgDiff;
                this.minAvg = this.parsedMetricPlots[0].density.average;
                this.domCluster = 'cluster--1';
            }
        }
        this.samplesWithLocationA = this.getSampleWithLocation(this.metricPlot.clusterDensities[0]);
        this.samplesWithLocationB = this.getSampleWithLocation(this.metricPlot.clusterDensities[1]);
    }
    get mapAvailable() {
        return (this.samplesWithLocationA.length > 0 && this.samplesWithLocationA.length > 0);
    }
    onSwitchTab(i) {
        this.options.forEach((tab) => (tab.active = false));
        this.options[i].active = true;
        this.mode = this.options[i].mode;
    }
    get parsedMetricPlots() {
        const currentMetricPlots = this.metricPlot.clusterDensities.map((c, ix) => {
            const rawMetric = {
                average: c.avg,
                max: c.max,
                min: c.min,
                percentil_05: c.percentile05,
                percentil_025: c.percentile025,
                percentil_075: c.percentile075,
                present_in_num_samples: c.samples.length,
                samples: c.samples.map((s) => {
                    var _a, _b;
                    return {
                        rank: s === null || s === void 0 ? void 0 : s.rank,
                        code: (_a = s === null || s === void 0 ? void 0 : s.sample) === null || _a === void 0 ? void 0 : _a.code,
                        name: (_b = s === null || s === void 0 ? void 0 : s.sample) === null || _b === void 0 ? void 0 : _b.name,
                        value: s === null || s === void 0 ? void 0 : s.value,
                    };
                }),
            };
            const myCluster = new Cluster_1.default(ix);
            myCluster.name = this.metricPlot.boxplot.clusters[ix].name;
            const currentMetricCluster = new Density_1.DensityResult(myCluster, new Density_1.DensityData(rawMetric));
            return currentMetricCluster;
        });
        currentMetricPlots.sort((a, b) => b.cluster.idx - a.cluster.idx);
        return currentMetricPlots;
    }
    get totalSamples() {
        if (!this.plots)
            return 0;
        return this.plots.reduce(function (prev, curr) {
            return prev + curr.cluster.samples.length;
        }, 0);
    }
    get totalParcels() {
        if (!this.plots)
            return 0;
        const parcels = {};
        this.plots.forEach((p) => p.cluster.samples.forEach((s) => {
            if (!s.parcel)
                return;
            parcels[s.parcel.id] = true;
        }));
        return Object.keys(parcels).length;
    }
    onChangeMetricType() {
        let metrics = this.metrics;
        if (this.selectedMetricType !== 'ALL') {
            metrics = metrics.filter((m) => (m === null || m === void 0 ? void 0 : m.typeCode) === this.selectedMetricType);
        }
        this.filteredMetrics = metrics;
        this.selectedMetric = metrics.length ? metrics[0] : null;
    }
    getSampleWithLocation(density) {
        const samples = [];
        density.samples.forEach((sample) => {
            var _a;
            if ((_a = sample.sample) === null || _a === void 0 ? void 0 : _a.location) {
                samples.push(sample);
            }
        });
        return lodash_1.default.uniqBy(samples, 'sample.id');
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], MetricPlot.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], MetricPlot.prototype, "density", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], MetricPlot.prototype, "metricName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], MetricPlot.prototype, "metrics", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], MetricPlot.prototype, "metricPlot", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'bio' })
], MetricPlot.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('selectedMetricType')
], MetricPlot.prototype, "onChangeMetricType", null);
MetricPlot = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Loader: Loader_vue_1.default,
            Tabs: Tabs_vue_1.default,
            BoxPlot: BoxPlot_vue_1.default,
            Probability: Probability_vue_1.default,
            Map: Map_vue_1.default,
            MapPin: lucide_vue_next_1.MapPin,
        },
    })
], MetricPlot);
exports.default = MetricPlot;
